/** @type {import("../types/mutations/token").TokenMutationKeys} */
const token_mutation_keys = { 
    SET: "TOKEN/SET"
}

/** @type {import("../types/mutations/token").TokenMutations} */
const token_mutations = {
    [token_mutation_keys.SET]: (state, token) => state.token = token,
}

export default token_mutations;

export { token_mutation_keys }